import { render, staticRenderFns } from "./textOutlineController.vue?vue&type=template&id=c0ed70e0&"
import script from "./textOutlineController.vue?vue&type=script&lang=ts&"
export * from "./textOutlineController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports